export const parseMarkdownBold = (text) => {
  const parts = text?.split(/(\*\*[^*]+\*\*)/g); // split by bold tokens
  return parts.map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return <span key={index}>{part}</span>;
  });
};

const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
export const getStrapiMedia = (media) => {
  if (!media) return "";
  const temp = media.startsWith("http") ? media : `${IMAGE_BASE_URL}${media}`;
  return temp;
};
